import { Link, useLocation } from "react-router-dom";

// Discreet footer that appears on every non-admin page so the legal pages
// are always one tap away, but never in the way of the game.
const Footer = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  const links = [
    { to: "/privacy", label: "Privacy", testId: "footer-privacy" },
    { to: "/terms", label: "Terms", testId: "footer-terms" },
    { to: "/dmca", label: "DMCA", testId: "footer-dmca" },
    { to: "/legal-notices", label: "Legal Notices", testId: "footer-legal" },
  ];

  return (
    <footer
      data-testid="app-footer"
      className="mt-8 border-t-4"
      style={{
        background: "#FFF9E6",
        borderColor: "#2b2b2b",
        color: "#484848",
        // Reserve space below the footer for the fixed bottom nav on mobile
        // so the legal links never disappear behind it. Desktop (lg) hides
        // BottomNav so we only need the buffer on smaller screens.
        marginBottom: "max(env(safe-area-inset-bottom), 4px)",
      }}
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs">
        <div className="flex items-center gap-2">
          <span aria-hidden="true">☕</span>
          <span>
            67Cafe — a pretend hangout. Coins are imaginary. Coffee is not.
          </span>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-3">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className="underline"
              style={{ color: "#484848" }}
            >
              {l.label}
            </Link>
          ))}
          <a
            href="mailto:mohammed@alghafly.com"
            data-testid="footer-contact"
            className="underline"
            style={{ color: "#484848" }}
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
